import React, {useState, useEffect, useReducer} from 'react';
import { connect } from "react-redux"
import { Dimmer, Loader, Transition } from 'semantic-ui-react';
//import { useRouter } from '../../hooks/useRouter';

import GlobalContext from './../../contexts/GlobalContext';
import API, { ResponseManagement, ErrorManagement } from './../../API';
import Navigation from './../Navigation/Navigation';
import Utility from './../../Utility';
import GlobalReducer from './../../contexts/GlobalReducer';
import * as GlobalType from './../../contexts/GlobalType';
import { useParams, useMatch, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NotifContext from './../../contexts/NotifContext';
import ModalContext from './../../contexts/ModalContext';
import NotifReducer from './../../contexts/NotifReducer';
import { ADD_NOTIF } from './../../contexts/NotifType';
import Auth from '../../Auth';
//import ModalAddBankCard from "../ModalAddBankCard/ModalAddBankCard";
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";
import {displayToastErrorFromResponse} from "@components/TradsErrorPages/ErrorUtil";


const mapProps = state => ({
  hasModule: state.authentication.hasModule,
  //globalEstablishmentCollection: state.establishmentCollection.establishmentCollection,
  //isActivatedBank: state.bank.isActivated,
  //cards: state.bank.cards
});

const mapDispatch = (dispatch) => ({
  //checkIsActivated: dispatch.bank.checkIsActivatedAsync,
  setAuthenticationInfos: dispatch.authentication.setAuthenticationInfos,
  loadCommon: dispatch.common.load,
  //setEstablishmentCollection: dispatch.establishmentCollection.load,
})


/**
 * Chargement des données primaire
 * @param {object} props.history
 * @param {object} props.match
 * @param {object} props.login
 */
const LoaderData = (props) => {

  const [dataLoaded, setDataLoad] = useState(false);
  const [urlLang, setUrlLang] = useState('');
  const [establishmentState] = useState({});
  const [languagesState] = useState([]);
  const [countriesState] = useState([]);
  const [identityDocumentsState] = useState([]);
  const [translationsState] = useState([]);
  const [userState] = useState({});
  const [listDossierState] = useState([]);
  const [listResaState] = useState([]);
  const [listParametresState] = useState([]);
  const [userActionTypesState] = useState([]);
  const [userActionsState] = useState([]);
  const [headerPageState] = useState({});
  const [connectedState] = useState(true);
  const [hasMdpState] = useState(null);
  const [authenticationStatusState] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [isRedirectState, setIsRedirectState] = useState(false);
  const [notifState, notifDispatch] = useReducer(NotifReducer, { notifs: [] });
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [bookingFolderId, setBookingFolderId] = useState(null);

  //const router = useRouter();


  const currentPathname = window.location.pathname
  const location = useLocation();

  const fromSelfCheckin = useFromSelfCheckin(location);

  let { token, lang, id } = useParams();
  //let Params = useParams();
  //console.log(Params)

  const match = useMatch("/:token/:lang/");
  //console.log(match)

  let tabUrlMatch = {}
  tabUrlMatch.preCheckIn = useMatch("/:token/:lang/preCheckIn/:id")
  tabUrlMatch.checkin = useMatch("/:token/:lang/checkin/:id")
  tabUrlMatch.bookings = useMatch("/:token/:lang/bookings")
  tabUrlMatch.bookingFolderInformations = useMatch("/:token/:lang/bookingFolderInformations/:id")
  tabUrlMatch.signIn = useMatch("/:token/:lang/signIn")

  let navigate = useNavigate();

  // Verifie et set une langue
  const checkSetLang = (lang) => {
    if (!['FR', 'EN', 'IT', 'ES', 'DE'].includes(lang)) lang = "FR";
    localStorage.setItem('lang', lang);
    setUrlLang(lang);
  }

  useEffect(() => {
    // TODO: placer initialisation globalState
    // setter la langue de l'utilisateur lors de la récupération des données
    if (Auth.isAuthenticated() === true) {
      checkSetLang(lang);
      setDataLoad(false);
    }
  }, [token, lang]); // faut rajouter cette protection aussi et virer un truc dans useBankForm



  // Ce useEffect vérifie si l'utilisateur est authentifié et si l'URL correspond
  // à une page de pré-checkin ou checkin. Dans ce cas, il force le rechargement
  // des données en réinitialisant l'état dataLoad.
  useEffect(() => {
    // Détermine si on doit forcer le rechargement basé sur l'URL
    const shouldForceReload = (tabUrlMatch.preCheckIn || tabUrlMatch.checkin);

    // Si l'utilisateur est authentifié et que le rechargement est nécessaire, on réinitialise la variable dataLoad à false. Permet de charger la page de preCheckin
    if (Auth.isAuthenticated() && shouldForceReload) {
      setDataLoad(false);
    }
  }, [currentPathname]);

  useEffect(() => {

    let mounted = true;
    let isRedirect = false;
    if (!Utility.isValidToken(token)) {
      setIsRedirectState(true);
    } else {
      API
        .get(Utility.getUrlAjax('informationsAction'))
        .then(response => {
          ResponseManagement(response,
            () => {
              if (mounted) {
                response.data.data.translations.bookingsEnOption = "En Option"

                response.data.data.translations.someNoModifInformation = "Certaines informations ne sont pas modifiables, car vous avez au moins une réservation en cours."
                response.data.data.translations.headerModalAddNewBooking = "Faire une réservation"
                response.data.data.translations.yes = "Oui"
                response.data.data.translations.no = "Non"
                response.data.data.translations.successCancelBooking = "Votre demande d'annulation à bien été prise en compte";
                response.data.data.translations.addNewBooking = "Souhaitez-vous faire une nouvelle réservation ?";

                response.data.data.translations.service = "Service";
                response.data.data.translations.location = "Location";

                response.data.data.translations.error_invoices_archives_not_found =
                  "Archive des factures introuvable";
                response.data.data.translations.error_no_invoices_found =
                  "Factures introuvables";

                response.data.data.translations.modalCheckInFormPartOneSociety = "Société";
                response.data.data.translations.modalCheckInFormPartOneLastName = "Veuillez saisir un Nom de famille ou une Société"

                response.data.data.translations.prechecking =
                  "Faire mon pré-check-in";

                response.data.data.translations.downloadFolderInvoices =
                  "Télécharger les factures du dossier";

                response.data.data.translations.sendMailFolderInvoices =
                  "Envoyer les factures du dossier par mail";

                response.data.data.translations.handleInvoices =
                  "Factures";

                response.data.data.translations.downloadAllInvoices =
                  "Télécharger toutes les factures du dossier";

                response.data.data.translations.sendMailAllInvoices =
                  "Envoyer les factures du dossier sur cet email";

                response.data.data.translations.sendMailSingleInvoice =
                  "Envoyer cette facture par email";

                response.data.data.translations.success_email_sent =
                  "Votre email a été envoyé avec succés";

                response.data.data.translations.displayCancelledBookings =
                  "Afficher les résas annulées";
                response.data.data.translations.hideCancelledBookings =
                  "Masquer les résas annulées";

                response.data.data.translations.cancelBookingDRW =
                  "Annuler ma demande de réservation";

                // response.data.data.displayControl.addExtraEarlyCheckIn = true;
                // response.data.data.displayControl.bookingEngineLink = true;
                // response.data.data.displayControl.bookingsListing = true;
                // response.data.data.displayControl.earlyCheckInForm = false;
                // response.data.data.displayControl.messaging = true;

                //HANDLE REDIRECTIONS///////////////////////////////////////////////////////////////////////////////////
                const displayControlData = response.data.data.displayControl;
                const isAuth = response.data.data.authenticationStatus == 1 ? true : false;


                if (((tabUrlMatch.preCheckIn || tabUrlMatch.checkin) && !displayControlData.earlyCheckInForm && !displayControlData.selfCheckinModule)
                  || (tabUrlMatch.bookings && !displayControlData.bookingsListing)
                  || ((tabUrlMatch.preCheckIn || tabUrlMatch.checkin) && !fromSelfCheckin.isFromSelfCheckin && !response.data.data?.isMailValid)
                ) {

                  if (((tabUrlMatch.bookings && !displayControlData.bookingsListing)
                    || (tabUrlMatch.checkin && !displayControlData.earlyCheckInForm))
                    && isAuth) {

                    isRedirect = true;
                    navigate(
                      `/${token}/${lang}/`,
                      { state: { from: location.pathname } }
                    );
                  } else if (!fromSelfCheckin.isFromSelfCheckin && (!response.data.data.hasMdp || (!response.data.data?.isMailValid && tabUrlMatch.preCheckIn))) {

                    isRedirect = true;
                    let manualUrl = '/generateTemporaryLink';
                    let dataForLink = {
                      customerAreaId: response.data.data.user.customerAreaId,
                      establishmentId: response.data.data.establishment.id,
                      type: "initializePassword",
                      langIso: lang,
                      expirationDate: "",
                      data: [],
                    };

                    API.post(Utility.getUrlAjax() + manualUrl, dataForLink).then(response => {
                      ResponseManagement(response,
                        () => {
                          if (response.data.success == "true") {
                            navigate(
                              `/${response.data.data.token}/${lang}/login/initializePassword`, //! Changement suite a la MR du 24/05/2024, il faut le nouveau token ici (a surveiller mais ça regles le problème de redirection en local ) http://git.misterbooking.lan/AdrienT/ExperienceClient/-/merge_requests/242/commits?commit_id=d1738aa0413f0a869a2c9a385c34c371da066c57
                              { state: { from: location.pathname } }
                            );
                          }
                        },
                        () => {
                        }
                      );
                    }).catch(error => {
                      ErrorManagement(error, () => {
                      });
                    })
                  } else if (!fromSelfCheckin.isFromSelfCheckin) {
                    isRedirect = true;
                    /*router.push({
                      pathname: `/${token}/${lang}/login`,
                      state: {from: currentPathname}
                    })*/
                    navigate(
                      `/${token}/${lang}/login`,
                      {
                        state: { from: location.pathname }
                      }
                    );
                  }
                  //  else { // cAS DE REDIRECT VERS CHECKIN VIA SELFCHECKIN
                  //   isRedirect = true;
                  //   router.push({
                  //     pathname: `/${token}/${lang}/checkin/${router.match.params.id}`,
                  //     state: {from: currentPathname}
                  //   })
                  // }
                } else if (tabUrlMatch.preCheckIn && (displayControlData.earlyCheckInForm || displayControlData.selfCheckinModule)) {
                  //isRedirect = true;
                  /*router.push({
                    pathname: `/${token}/${lang}/checkin/${router.match.params.id}`,
                    state: {
                      from: currentPathname,
                      isMailOTA: !response.data.data?.isMailValid
                    }
                  })*/

                  /*navigate(
                    `/${token}/${lang}/checkin/${id}`
                  );*/
                } else if (tabUrlMatch.bookingFolderInformations) {

                  isRedirect = true;
                  /*router.push({
                    pathname: `/${token}/${lang}/bookings/${router.match.params.id}`,
                    state: {from: currentPathname}
                  })*/
                  navigate(
                    `/${token}/${lang}/bookings/${id}`,
                    {
                      state: { from: currentPathname }
                    }
                  );
                } else if (isRedirectState === true || tabUrlMatch.signIn) {

                  isRedirect = true;
                  /*router.push({
                    pathname: `/${token}/${lang}/login`,
                    state: {from: currentPathname}
                  })*/
                  navigate(
                    `/${token}/${lang}/login`,
                    {
                      state: { from: currentPathname }
                    }
                  );
                }
                ////////////////////////////////////////////////////////////////////////////////////////////////////////

                if (!isRedirect) {

                  dispatch({ type: GlobalType.INIT_ESTAB, payload: response.data.data.establishment });
                  dispatch({ type: GlobalType.INIT_HASMDP, payload: response.data.data.hasMdp });
                  dispatch({ type: GlobalType.INIT_AUTHSTATUS, payload: response.data.data.authenticationStatus });
                  dispatch({ type: GlobalType.INIT_LANGUAGES, payload: response.data.data.languages });
                  dispatch({ type: GlobalType.INIT_COUNTRIES, payload: response.data.data.countries });
                  dispatch({ type: GlobalType.INIT_IDENTITY_DOCUMENTS, payload: response.data.data.identityDocuments });
                  dispatch({ type: GlobalType.INIT_TRANSLATIONS, payload: response.data.data.translations });
                  dispatch({ type: GlobalType.INIT_USER, payload: response.data.data.user });
                  dispatch({ type: GlobalType.INIT_USER_ACTION_TYPES, payload: response.data.data.userActionTypes });
                  dispatch({ type: GlobalType.INIT_USER_ACTIONS, payload: response.data.data.userActions });
                  dispatch({ type: GlobalType.INIT_LEGAL_INFO, payload: response.data.data.legalInfo });
                  dispatch({ type: GlobalType.INIT_MESSAGES, payload: response.data.data.messages });
                  dispatch({ type: GlobalType.INIT_DISPLAY_CONTROL, payload: response.data.data.displayControl });
                  dispatch({ type: GlobalType.INIT_ESTAB_COLLECTION, payload: response.data.data.establishmentCollection });
                  dispatch({ type: GlobalType.INIT_BY_ORGA, payload: response.data.data.espaceClientByOrga });
                  dispatch({ type: GlobalType.INIT_ETAB_REF, payload: response.data.data.id_etab_reference });
                  dispatch({ type: GlobalType.INIT_MOT_CHAMBRE, payload: response.data.data.affMotChambre });
                  dispatch({ type: GlobalType.INIT_FIELD_RESIDENT_PARAM, payload: response.data.data.checkInFieldParameters });


                  props.loadCommon({ displayControl: response.data.data.displayControl })

                  //props.setEstablishmentCollection( {establishmentCollection : response.data.data.establishmentCollection} )
                  //console.log( props.globalEstablishmentCollection )

                  //props.checkIsActivated({establishementId: response.data.data.establishment.id});
                  // if (!fromSelfCheckin.isFromSelfCheckin) props.checkIsActivated({establishementId: response.data.data.establishment.id});
                  let authObject = {
                    authenticationStatus: response.data.data.authenticationStatus,
                    hasMdp: response.data.data.hasMdp,
                    hasModule: response.data.data.hasModule,
                    isBookerHasMailOTA: !response.data.data?.isMailValid
                  }
                  props.setAuthenticationInfos(authObject);

                  if (response.data.data.messages && response.data.data.messages.length > 0) {
                    response.data.data.messages.forEach(message => {
                      if (message.author === 'hotel' && message.status === 'new') {
                        notifDispatch({ type: ADD_NOTIF, payload: message });
                      }
                    })
                  }
                  setDataLoad(true);
                  setIsLoading(false);
                  setVisible(true);
                }
              }
            },
            () => {
              displayToastErrorFromResponse(response)
              navigate(
                `/${token}/${lang}/login`,
                {
                  state: { from: currentPathname }
                }
              );
              // var timeOut = setTimeout(() => {
              // clearTimeout(timeOut);
              //setIsRedirectState(true);
              // }, 5500);
            }
          );
        })
        .catch(error => {
          console.error(error)
          ErrorManagement(error, () => {
            var timeOut = setTimeout(() => {
              clearTimeout(timeOut);
              /*router.push({
                pathname: `/${token}/${lang}/login`,
                state: {from: currentPathname}
              })*/
              navigate(
                `/${token}/${lang}/login`,
                {
                  state: { from: currentPathname }
                }
              )
            }, 5500);
          });
        })
    }
    return () => mounted = false;
  }, [localStorage.getItem('lang'), token, currentPathname]);// eslint-disable-line react-hooks/exhaustive-deps

  const initialState = {
    urlLang: urlLang,
    connected: connectedState,
    hasMdp: hasMdpState,
    authenticationStatus: authenticationStatusState,
    establishment: establishmentState,
    languages: languagesState,
    countries: countriesState,
    identityDocuments: identityDocumentsState,
    translations: translationsState,
    user: userState,
    listDossier: listDossierState,
    listResa: listResaState,
    listParametres: listParametresState,
    headerPage: headerPageState,
    userActionTypes: userActionTypesState,
    userActions: userActionsState
  }

  const [state, dispatch] = useReducer(GlobalReducer, initialState);

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <>
      {
        dataLoaded ?
          <GlobalContext.Provider value={[state, dispatch]}>
            <NotifContext.Provider value={[notifState, notifDispatch]}>
              <ModalContext.Provider value={{
                modalIsOpen, setModalIsOpen,
                bookingFolderId, setBookingFolderId
              }}>
                <Dimmer.Dimmable dimmed={isLoading} blurring>
                  <Dimmer page active={isLoading} inverted>
                    <Loader>{(lang === 'FR') ? 'Chargement' : 'Loading'}</Loader>
                  </Dimmer>
                </Dimmer.Dimmable>
                <Transition visible={visible} animation="fade" duration={900}>
                  <Navigation location={location} />
                </Transition>
                <ToastContainer enableMultiContainer position="bottom-right" />
                {/*{isRedirectLogin()}*/}
                {/*{isRedirectCheckin()}*/}
                {/*{isRedirectBooking()}*/}

                {/*props.hasModule && !fromSelfCheckin.isFromSelfCheckin && props.isActivatedBank ? <ModalAddBankCard bookingFolderId={bookingFolderId} countBankCards={props.cards.length} id="modalAddBankCardContainer" /> : ""*/}
              </ModalContext.Provider>
            </NotifContext.Provider>
          </GlobalContext.Provider>
          :
          <Dimmer.Dimmable dimmed={true} blurring>
            <Dimmer page active={true} inverted>
              <Loader>{(lang === 'FR') ? 'Chargement' : 'Loading'}</Loader>
            </Dimmer>
          </Dimmer.Dimmable>
      }
    </>
  )
}

export default connect(mapProps, mapDispatch)(LoaderData);
//export default connect(mapDispatch)(LoaderData);
